let base = window._env_.VUE_APP_AUTH_HOST
let admin = window._env_.VUE_APP_ADMIN_HOST
export const login = params => {
  if (params.captchacode) {
    const headers = {
      'SJ-CaptchaCode-Token': params.captchaCodeToken
    }
    delete params.captchaCodeToken
    return axios.post(`${base}/login`, params, {headers: headers})
  }
  return axios.post(`${base}/login`, params)
}
export const getPermission = params => {
  return axios.get(`${admin}/permission`)
}
export const getApiPermission = params => {
  return axios.get(`${admin}/api_permissions`)
}
export const fetchCaptchaCode = params => {
  return axios.get(`${base}/captchacode`)
}
export const refreshToken = params => {
  return axios.post(`${base}/refresh`, params)
}
export const getVersion = params => {
  return axios.get(`${admin}/version`, params)
}




// WEBPACK FOOTER //
// ./src/views/login/login.api.js